/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import styled from '@emotion/styled'
import { TmrProduct, Products, ProductInfoField } from 'stylewhere/api'
import { Box, Modal, ModalTitle, Image } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { AppStore } from 'stylewhere/shared'
import _ from 'lodash'

interface Props {
  onClose: () => void
  product: TmrProduct
  visible: boolean
  overrideProductInfoFields?: ProductInfoField[]
}

const ProductDetailsRow: React.FC<{ label: string; value?: string; last?: boolean }> = ({ label, value, last }) => {
  return (
    <Box
      data-testid={`product-details-row`}
      flex
      row
      justify="space-between"
      style={{ borderBottom: last ? undefined : '1px solid #e0e0e0', lineHeight: '33px' }}
    >
      <Box style={{ fontSize: 14, marginRight: 5 }}>{label}</Box>
      <Box style={{ fontWeight: 700, wordWrap: 'break-word', flex: 1, textAlign: 'end' }}>{value ?? '--'}</Box>
    </Box>
  )
}

export class ProductInfoModal extends Component<Props> {
  productFields: ProductInfoField[] = [
    { path: 'color.value', label: __(T.misc.color) },
    { path: 'material.value', label: __(T.misc.material) },
    { path: 'size.value', label: __(T.misc.size) },
    { path: 'style.value', label: __(T.misc.style) }
  ]

  getProductFields = () => {
    const { overrideProductInfoFields } = this.props
    if (overrideProductInfoFields) {
      return overrideProductInfoFields
    }
    return this.productFields
  }

  getProductCode = (product) => product.code

  render() {
    const { visible, onClose, product } = this.props

    return (
      <Modal size="md" onClose={onClose} visible={visible} fullContent showCloseButton>
        <Box flex={3} style={{ minWidth: 0 }}>
          <ModalTitle
            title={__(T.misc.product)}
            data-testid={`product-modal-title`}
            style={{ flex: 0, paddingTop: 20, paddingBottom: 15, marginLeft: 35 }}
          />

          <Box flex row style={{ marginTop: 25 }} center>
            <Box pr={25} style={{ maxWidth: '90%', minWidth: '90%' }} center>
              {AppStore.getShowProductImage() && (
                <Image src={Products.getImageUrl(product)} width={200} height={200} style={{ marginBottom: 16 }} />
              )}
              <ProductTitle data-testid={`product-title`}>{this.getProductCode(product)}</ProductTitle>
              <div data-testid={`product-description`}>{product.description}</div>
              <Box mt={16} mb={16}>
                {this.getProductFields().map((field, idx, all) => {
                  return (
                    <ProductDetailsRow
                      key={field.path}
                      label={field.label}
                      value={_.get(product, field.path ?? '', 'n/a')}
                      last={idx === all.length - 1}
                    />
                  )
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    )
  }
}

const ProductTitle = styled.div`
  font-size: 28px;
  font-weight: bold;
  line-height: 32px;
`
